import DoughnutChart from "../../components/Charts/DougnutChart";
import LineChart from "../../components/Charts/LineChart";
import CardChartLayout from "../../layouts/Card/ChartLayout";
import { ChartType, ThemeType } from "../../types";
import { ChartOptions } from "chart.js";
import BarChart from "../../components/Charts/BarChart";
import PieChart from "../../components/Charts/PieChart";
import { DataType } from "../../types/dataType";

type CardChartProps<T, U> = {
  className?: string;
  width?: string | number;
  height?: string | number;
  data?: T;
  theme?: ThemeType;
  options?: U;
  title?: string;
  subtitle?: string;
  type?: ChartType;
  hover?: boolean;
};

const CardChart = <
  T extends DataType,
  U extends ChartOptions<"line" | "bar" | "doughnut">
>({
  className,
  data,
  height,
  options,
  theme,
  width,
  title,
  type,
  subtitle,
  hover,
}: CardChartProps<T, U>): JSX.Element => {
  const chartProps = { data, theme, width, height, options };
  const renderChart = (t: ChartType = "line") => {
    if (!data?.data) {
      return (
        <div className="w-full h-full grid justify-center items-center">
          <p className="text-sm text-red-500 italic">No Data</p>
        </div>
      );
    }
    switch (t) {
      case "line":
        return <LineChart {...chartProps} />;
      case "doughnut":
        return <DoughnutChart {...chartProps} />;
      case "pie":
        return <PieChart {...chartProps} />;
      case "bar":
        return <BarChart {...chartProps} />;
      default:
        return <LineChart {...chartProps} />;
    }
  };
  return (
    <CardChartLayout
      className={className}
      theme={theme}
      title={title}
      subtitle={subtitle}
      hover={hover}
    >
      {renderChart(type)}
      {/* <Growth></Growth> */}
    </CardChartLayout>
  );
};

export default CardChart;
